import * as types from '../constants/action-types';
import { Attendees } from '../../../../api/api-attendees';

export function fetchAttendees (bookingId, callback) {
  return dispatch => {
    dispatch({ type: types.ATTENDEES_REQUEST });

    Attendees.read(bookingId, (response) => {
      if (response.error) {
        return dispatch({ type: types.ATTENDEES_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.ATTENDEES_SUCCESS,
        payload: response
      });
    });
  };
}

export function createAttendee (bookingId, rsvp, token, callback) {
  return dispatch => {
    dispatch({ type: types.ATTENDEE_CREATE_REQUEST });

    Attendees.create(bookingId, rsvp, token, (response) => {
      if (response.error) {
        return dispatch({ type: types.ATTENDEE_CREATE_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.ATTENDEE_CREATE_SUCCESS,
        payload: response
      });
    });
  };
}

export function createAttendeeInvite (bookingId, payload, token, callback) {
  return dispatch => {
    dispatch({ type: types.ATTENDEE_CREATE_INVITE_REQUEST });

    Attendees.createInvites(bookingId, payload, token, (response) => {
      if (response.error) {
        return dispatch({ type: types.ATTENDEE_CREATE_INVITE_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.ATTENDEE_CREATE_INVITE_SUCCESS,
        payload
      });
    });
  };
}

export function updateAttendee (bookingId, rsvp, token, callback) {
  return dispatch => {
    dispatch({ type: types.ATTENDEE_UPDATE_REQUEST });

    Attendees.update(bookingId, rsvp, token, (response) => {
      if (response.error) {
        return dispatch({ type: types.ATTENDEE_UPDATE_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.ATTENDEE_UPDATE_SUCCESS,
        payload: response
      });
    });
  };
}
